import { useState } from 'react';
import { Grid } from '@mui/material';
import { TextInput } from '@shared/inputs/TextInput';
import { FormFooter, PageContent } from '@styles/Admin-tools/Workflows/WorkflowsStyle';
import { CancelButton, SaveButton } from '@shared/inputs/Buttons';

import { IParentStepModalFormProps, IWorkflowStep } from '../../types';
import CustomList from '../CustomList/CustomList';

export const ParentStepModalForm = ({
  setFieldValue,
  handleClose,
  currentStep,
  selectedWorkflow,
}: IParentStepModalFormProps) => {
  const [step, setStep] = useState<IWorkflowStep | null>(currentStep);

  const handleChangeDestStep = (step: IWorkflowStep | null) => {
    if (step) {
      setFieldValue?.('parentWorkflowStepId', step.id);
      setStep(step);
    }
  };

  return (
    <>
      <PageContent>
        <Grid container spacing={2} mb={2}>
          <Grid item sm={12}>
            <TextInput disabled value={step?.name} label="Parent step" />
          </Grid>

          <Grid item sm={12}>
            <CustomList
              selectedWorkflow={selectedWorkflow}
              defaultSelectedStep={currentStep?.id || ''}
              handleChangeDestStep={handleChangeDestStep}
            />
          </Grid>
        </Grid>
      </PageContent>

      <FormFooter>
        <CancelButton onClick={handleClose} />
        <SaveButton />
      </FormFooter>
    </>
  );
};
